import { ReactNode } from "react";

export default function TomtResultat({
  className,
  children,
}: {
  children: ReactNode;
  className?: string;
}): JSX.Element {
  return (
    <div
      className={`flex items-center justify-center bg-banner mx-5 h-[calc(100vh-390px)] bg-cover bg-bottom overflow-hidden z-0 max-h-screen ${className}`}
    >
      <div className="text-[2rem] mx-6">{children}</div>
    </div>
  );
}
